import { Location } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import { locale, messages } from '../i18n'
import Seo from '../../specific/components/Seo'
import LocalizedBreadCrumb, {
  BreadCrumbItems,
} from '../components/breadCrumb/LocalizedBreadCrumb'
import { SeoData } from '../types/Seo'
import CopyrightFooter from './footers/CopyRightFooter/CopyRightFooter'
import PageFooter from './footers/PageFooter/PageFooter'
import Header from './headers/Header'
import SelectorHeader from './headers/SelectorHeader'
import styles from './layout.module.scss'
import { IAppState } from '../context/context'
import { selectIsLoggedIn } from '../context/selectors/userSelectors'
import { Dispatch } from 'redux'
import * as UserActions from '../context/actions/userActions'
import { connect, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import AvisoTareasMantenimiento from './modal/AvisoTareasMantenimiento'
import {
  isMantenimientoNow,
  loadMantenimiento,
  setShown,
} from '../../shared/mantenimiento/store/mantenimientoSlice'

interface LayoutProps {
  isLoggedIn: boolean
  logout: () => void
  requireLogin?: boolean
  children: JSX.Element | JSX.Element[]
  beforeFooter?: () => JSX.Element | JSX.Element[]
  breadCrumItems?: BreadCrumbItems
  selector: boolean
  onGoBack?: () => void
  seoData: null | SeoData
  currentLocation?: 'cesta' | 'cita-previa' | 'other'
  hideTeLlamamos?: boolean
  maintenceModalHasBeenShown: boolean
  setMaintenanceShown: () => void
  isMantenimientoActivo: boolean
}

const Layout: React.FC<LayoutProps> = ({
  isLoggedIn,
  logout,
  requireLogin = false,
  children,
  beforeFooter,
  breadCrumItems,
  selector,
  onGoBack,
  seoData,
  currentLocation,
  hideTeLlamamos,
  maintenceModalHasBeenShown,
  setMaintenanceShown,
  isMantenimientoActivo,
}) => {
  const dispatch = useDispatch()

  // This logs the user out if they somehow get here without the
  // proper info in the userData. It must be in a useEffect (and
  // separated from the return null below) because otherwise we
  // create an infite-logout-loop.
  useEffect(() => {
    if (requireLogin && !isLoggedIn) {
      logout()
    }
  }, [isLoggedIn, requireLogin])

  if (requireLogin && !isLoggedIn) {
    return null
  }
  const onGoBackDefault = () =>
    typeof window !== 'undefined' && window.history.go(-1)

  useEffect(() => {
    dispatch(loadMantenimiento())
  }, [])

  const [openModal, setOpenModal] = useState(false)
  useEffect(() => {
    if (!maintenceModalHasBeenShown && isMantenimientoActivo) {
      setOpenModal(true)
      setMaintenanceShown()
    }
  }, [maintenceModalHasBeenShown, isMantenimientoActivo])

  return (
    <IntlProvider locale={locale} messages={messages}>
      <React.Fragment>
        {typeof window !== 'undefined' || seoData ? null : (
          <Location>
            {({ location }) => {
              const { pathname } = location
              const splitPath = pathname.split('/')
              if (
                typeof window === 'undefined' &&
                !(
                  splitPath.length >= 3 &&
                  splitPath[splitPath.length - 3] === 'michelin' &&
                  splitPath[splitPath.length - 2] !== ''
                )
              ) {
                console.log('=== NEEDS SEO DATA ===' + '\n' + '\n')
                console.log(location.pathname + '\n' + '\n')
              }
              return null
            }}
          </Location>
        )}

        {requireLogin && (
          <Helmet>
            <meta name={'robots'} content={'noindex,nofollow'} />
          </Helmet>
        )}

        <Seo seoData={seoData} />
        <div
          className={`${
            breadCrumItems ? styles.layout_wrapper_breadcrum : ''
          } ${styles.mainWrapper}`}>
          {selector ? (
            <SelectorHeader
              currentLocation={currentLocation}
              onGoBack={onGoBack || onGoBackDefault}
              hideTeLlamamos={hideTeLlamamos}
            />
          ) : (
            <Header
              esPath={seoData ? seoData.url_es : '/'}
              caPath={seoData ? seoData.url_ca : '/'}
            />
          )}

          {breadCrumItems ? (
            <LocalizedBreadCrumb items={breadCrumItems} />
          ) : null}

          <main
            className={breadCrumItems ? styles.main_breadcrumb : styles.main}>
            <div className={styles.container}>{children}</div>
          </main>

          {beforeFooter && beforeFooter()}

          <footer>
            {selector ? (
              <div className={styles.desktopOnly}>
                <CopyrightFooter />
              </div>
            ) : (
              <PageFooter />
            )}
          </footer>
          <AvisoTareasMantenimiento
            setOpenModal={setOpenModal}
            openModal={openModal}
            setMaintenanceShown={setMaintenanceShown}
          />
        </div>
      </React.Fragment>
    </IntlProvider>
  )
}

const mapStateToProps = (state: IAppState) => {
  return {
    isLoggedIn: selectIsLoggedIn(state),
    maintenceModalHasBeenShown: state.mantenimiento.hasBeenShown,
    isMantenimientoActivo: isMantenimientoNow(state),
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    logout: () => dispatch(UserActions.logout()),
    setMaintenanceShown: () => dispatch(setShown()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Layout)
